export default function leftFillNum(num: string | number, targetLength = 4) {
  return num.toString().padStart(targetLength, "0")
}